const allowedTags = new Set(["P", "DIV", "SPAN", "BR", "STRONG", "B", "EM", "I", "U", "S", "DEL",
    "H1", "H2", "H3", "H4", "H5", "H6", "UL", "OL", "LI", "BLOCKQUOTE", "A", "HR", "SUB", "SUP"]);
const discardedTags = new Set(["SCRIPT", "STYLE", "IFRAME", "OBJECT", "EMBED", "SVG", "MATH", "TEMPLATE"]);
const allowedStyles = ["font-size", "font-weight", "font-style", "text-align", "text-decoration", "color",
    "background-color", "line-height", "font-family"];

export function articleLink(url: string): string | undefined {
    try {
        const parsed = new URL(url, window.location.origin);
        return ["https:", "http:", "mailto:", "tel:"].includes(parsed.protocol) ? parsed.href : undefined;
    } catch {
        return undefined;
    }
}

export function articleHtml(html: string): string {
    const document = new DOMParser().parseFromString(html, "text/html");
    const clean = (parent: Element): void => {
        for (const element of Array.from(parent.children)) {
            if (discardedTags.has(element.tagName)) {
                element.remove();
                continue;
            }
            clean(element);
            if (!allowedTags.has(element.tagName)) {
                element.replaceWith(...Array.from(element.childNodes));
                continue;
            }
            const style = (element as HTMLElement).style;
            const styles = allowedStyles.map(property => [property, style.getPropertyValue(property)]);
            const href: string | undefined = element.tagName === "A" ? articleLink(element.getAttribute("href") || "") : undefined;
            const start: string | null = element.tagName === "OL" ? element.getAttribute("start") : null;
            for (const attribute of Array.from(element.attributes)) {
                element.removeAttribute(attribute.name);
            }
            for (const [property, value] of styles) {
                if (value && !/url\s*\(|expression\s*\(|\\/i.test(value)) {
                    style.setProperty(property, value);
                }
            }
            if (href) {
                element.setAttribute("href", href);
                element.setAttribute("target", "_blank");
                element.setAttribute("rel", "noopener noreferrer");
            }
            if (start && /^-?\d+$/.test(start)) {
                element.setAttribute("start", start);
            }
        }
    };
    clean(document.body);
    return document.body.innerHTML;
}
